/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Input_Slider_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "{label} slider" |
*
* @param {Input_Slider_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_slider_aria_label = /** @type {((inputs: Input_Slider_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Slider_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Curseur ${i?.label}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.label} Schieberegler`)
	if (locale === "it") return /** @type {LocalizedString} */ (`cursore ${i?.label}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.label} ползунок`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Control deslizante ${i?.label}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`${i?.label}滑块`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`${i?.label} スライダー`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`${i?.label} स्लाइडर`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.label} controle deslizante`)
	return /** @type {LocalizedString} */ (`${i?.label} slider`)
});